import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlugin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="plugin-2, build" maskId="round-filled-radius-1-stroke-1.5-IconPlugin2"><path d="M4 4.75C4 3.7835 4.7835 3 5.75 3H9.25C10.2165 3 11 3.7835 11 4.75V7H4V4.75Z" fill="currentColor"/><path d="M13 4.75C13 3.7835 13.7835 3 14.75 3H18.25C19.2165 3 20 3.7835 20 4.75V7H13V4.75Z" fill="currentColor"/><path d="M2 10.25C2 9.2835 2.7835 8.5 3.75 8.5H20.25C21.2165 8.5 22 9.2835 22 10.25V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V10.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlugin2;
